export const setMockToken = (username: string) => {
    // Set mock cookie with username value
    const expires = new Date(Date.now() + 10000).toUTCString(); // 10 seconds
    document.cookie = `ul.token.mock=${encodeURIComponent(username)};path=/;expires=${expires}`;
};

export const setMockTokenApp = (username: string) => {
    // Set mock cookie with username value
    const expires = new Date(Date.now() + 10000).toUTCString(); // 10 seconds
    document.cookie = `token=${username};path=/;expires=${expires}`;
};
